import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@copro/api";

type Variables = {
  fileUrl: string;
  newName: string;
  spaceId: string;
};

async function renameFileInGoogleDrive(variables: Variables) {
  // Only Drive-hosted files can be renamed remotely; links are a no-op.
  if (!variables.fileUrl.includes('drive.google.com')) return;

  const { error } = await apiClient
    .functions
    .invoke('rename-in-drive', {
      body: {
        fileUrl: variables.fileUrl,
        newName: variables.newName,
        spaceId: variables.spaceId,
      },
    });

  if (error) {
    throw error;
  }
}

export default function useRenameFileInGoogleDrive() {
  return useMutation({
    mutationFn: renameFileInGoogleDrive,
  });
}
